import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';
import { hideModal } from '../../actions/ModalActions';

function DidntBuyModal(props) {
  const { closeModal } = props;
  return (
    <div id="didnt-buy-modal">
      <div className="modal-body text-center">
        <p>Thank you for letting us know.</p>
        <ButtonV2 className="margin-top-2x" onClick={closeModal}>
          Continue Shopping
        </ButtonV2>
      </div>
    </div>
  );
}

DidntBuyModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DidntBuyModal);



// WEBPACK FOOTER //
// ./src/components/registryitem/DidntBuyModal.jsx